import { cdnApi } from '@/helpers/api'
import { defineStore } from 'pinia'

export interface NewsList {
  id: number
  name: string
  category: string
  imageThumbnail: string
  summary: string
  featured: boolean
  liveDate: string
}

export const useNewsStore = defineStore('News', {
  state: () => ({
    all: [] as NewsList[],
  }),
  getters: {
    getFiltered(state) {
      const categorized: { [key: string]: NewsList[] } = {
        all: state.all,
        general: state.all.filter((article) => article.category === 'general'),
        update: state.all.filter((article) => article.category === 'update'),
        sale: state.all.filter((article) => article.category === 'sale'),
        events: state.all.filter((article) => article.category === 'events'),
        community: state.all.filter((article) => article.category === 'community'),
        maintenance: state.all.filter((article) => article.category === 'maintenance'),
      }
      return (filter: string) => categorized[filter] ?? []
    },
    featuredHome(state) {
      return state.all.filter((x) => x.featured).slice(0, 3)
    },
  },
  actions: {
    async fetchAllNews() {
      const [{ data }, { data: archive }] = await Promise.all([cdnApi.get('/news'), cdnApi.get('/archived')])
      this.all = data.concat(archive)
    },
  },
})
